import { useMemo } from 'react';
import { DataServiceFactory, useDataService } from './ApiDataService';

const v3Url = `/api/v3`;

export function AnnotationsService(dataService = DataServiceFactory()) {
    function getAnnotations(entity, parameters) {
        let apiType = '';

        if (entity.type !== 'test') return Promise.resolve({ data: [] });
        if (entity.type === 'test') {
            apiType = 'service-tests';
        }
        const baseUrl = `${v3Url}/${apiType}/${entity?.uuid || entity?.name}/annotations/list`;
        return dataService.get(baseUrl, parameters);
    }

    return {
        getAnnotations,
    };
}

export function useAnnotationsService() {
    const dataService = useDataService();
    return useMemo(() => AnnotationsService(dataService), [dataService]);
}
